module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_clubs-queen.8e489541.svg";